import BaseComponent from "../../../../base/base_component";
import Event from "../../../../utils/event";
import {SYSTEM_EVENTS, USER_EVENTS} from "../../../../events/events";
import {AGE_ICON_TYPE_CSS_SELECTOR} from './age_responsible_game_consts';
import _ from '../../../../utils/underscore';
import {AGE_ICON_TYPE, AGE_ANALYTICS_DEFAULT} from './age_responsible_game_consts';
import { Check } from "@sparkware/app-utils";

let view = require('./view/age_responsible_game.html');

export default class AgeResponsibleGameComponent extends BaseComponent {

    static CLASS = 'AgeResponsibleGameComponent';

    /**
     *
     * @type {string}
     */
    static DIRECTIVE = 'cgp-directive-age_responsible_game';

    _selector = 'cgp-responsible-gaming-age-icon-component';

    init(params) {
        super.init(params);
        params = params || {};
        this._analytics = params.analytics || AGE_ANALYTICS_DEFAULT;
        this._iconType = params.iconType || AGE_ICON_TYPE.ROUND;
        if(_.isNullOrUndefined(params.responsibleGamblingView)) {
            this._responsibleGamblingView = this.serviceFactory.gameManagerService().responsibleGamblingView()
        } else {
            this._responsibleGamblingView = params.responsibleGamblingView;
        }
        this._subscribe();
    }

    start() {
        const rgLabel = this.serviceFactory.regulationService().getRegulation().getAgeResponsibleGamingLabel();
        let bakedHTML = this.bake(view, {
            minimumAge : this._getAgeThemeClass(),
            rgLabel: Check.isNullOrUndefined(rgLabel) ? "" : rgLabel,
            withRgLabel: !!rgLabel ? "cgp-themes-icons-age-label" : ""
        });
        this.setHTML(bakedHTML);
    }


    _subscribe() {
        this.onRootElementEvent(USER_EVENTS.ON_CLICK, () => {
            if (this._analytics) {
                Event.fire(SYSTEM_EVENTS.ANALYTIC_TRIGGER_ACTIVATED, this._analytics);
            }

            this._openResponsibleGamblingLink();
        });
    }

    _getAgeThemeClass() {
        let minimumAge = this.serviceFactory.skinService().getMinimumAge() + '';
        return AGE_ICON_TYPE_CSS_SELECTOR[this._iconType][minimumAge];
    }

    _openResponsibleGamblingLink() {
        this.serviceFactory.openLinkService().openResponsibleGamblingLink(this._responsibleGamblingView);
    }

}